
import { NoseurObject } from "@rivtn/noseur";
import { Actor, SanitizedResponse } from "../BaseService";
import { ConfigurationType, PloutousBaseService } from "./PloutousBaseService";

export interface IServiceConfiguration {
    key: any;
    options?: any;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    description: string;
    external_id: string;
    type: ConfigurationType;
    admin_write_only: boolean;
}

export class ServiceConfigurationAndMappingService extends PloutousBaseService {

    protected static instance: ServiceConfigurationAndMappingService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!ServiceConfigurationAndMappingService.instance) ServiceConfigurationAndMappingService.instance = new ServiceConfigurationAndMappingService();
        return ServiceConfigurationAndMappingService.instance;
    }

    queryServiceConfigurations(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<IServiceConfiguration>> {
        return this.report(this.transport.get("/api/v1/service/configuration", { query: this.normalizeParams(params) }));
    }

    createServiceConfiguration(payload: any): Promise<SanitizedResponse<IServiceConfiguration>> {
        return this.report(this.transport.post(`/api/v1/service/configuration`, payload));
    }

    updateServiceConfiguration(payload: Partial<IServiceConfiguration>): Promise<SanitizedResponse<IServiceConfiguration>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/service/configuration/${id}`, payload));
    }

    deleteServiceConfiguration(id: string): Promise<SanitizedResponse<IServiceConfiguration>> {
        return this.report(this.transport.delete(`/api/v1/service/configuration/${id}`));
    }

}
